import { createReducer, on, Action } from '@ngrx/store';
import { ConnectivityState } from './connectivity.state';
import { hasNetworkConnectionAction, noNetworkConnectionAction } from './connectivity.actions';
import { ConnectivityStatusEnum } from '../enums';

const initialState = new ConnectivityState();

const reducer = createReducer(
  initialState,
  on(hasNetworkConnectionAction, (state) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.isWifiConnected = ConnectivityStatusEnum.Connected;
    return newState;
  }),
  on(noNetworkConnectionAction, (state) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.isWifiConnected = ConnectivityStatusEnum.NotConnected;
    return newState;
  })
);

export function connectivityReducer(state: ConnectivityState | null, action: Action) {
  return reducer(state, action);
}
